"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Target_exports = {};
__export(Target_exports, {
  default: () => Target_default
});
module.exports = __toCommonJS(Target_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.2584 2.73583C20.2584 2.11293 19.5059 1.80028 19.0645 2.23977L17.4561 3.84122C17.3241 3.97258 17.25 4.1511 17.25 4.33728L17.25 6.04723L16.9361 6.36115C15.5535 5.14359 13.7376 4.40424 11.75 4.40424C7.41457 4.40424 3.9 7.9188 3.9 12.2542C3.9 16.5897 7.41457 20.1042 11.75 20.1042C16.0854 20.1042 19.6 16.5897 19.6 12.2542C19.6 11.0514 19.329 9.91011 18.8443 8.88964C18.7021 8.59032 18.3442 8.46295 18.0449 8.60514C17.7455 8.74733 17.6182 9.10523 17.7604 9.40455C18.1703 10.2675 18.4 11.2332 18.4 12.2542C18.4 15.9269 15.4227 18.9042 11.75 18.9042C8.07731 18.9042 5.1 15.9269 5.1 12.2542C5.1 8.58154 8.07731 5.60424 11.75 5.60424C13.4066 5.60424 14.921 6.20935 16.0855 7.21168L14.8078 8.48939C13.9737 7.81122 12.9087 7.40416 11.75 7.40416C9.07142 7.40416 6.9 9.57558 6.9 12.2542C6.9 14.9327 9.07142 17.1042 11.75 17.1042C14.4286 17.1042 16.6 14.9327 16.6 12.2542C16.6 11.9758 16.5765 11.7026 16.5312 11.4363C16.4757 11.1096 16.1659 10.8898 15.8392 10.9453C15.5125 11.0009 15.2927 11.3107 15.3482 11.6374C15.3822 11.8375 15.4 12.0435 15.4 12.2542C15.4 14.27 13.7658 15.9042 11.75 15.9042C9.73416 15.9042 8.1 14.27 8.1 12.2542C8.1 10.2383 9.73416 8.60416 11.75 8.60416C12.5782 8.60416 13.3409 8.87935 13.9533 9.3439L12.3967 10.9005C12.2009 10.8068 11.9816 10.7543 11.75 10.7543C10.9216 10.7543 10.25 11.4259 10.25 12.2543C10.25 13.0828 10.9216 13.7543 11.75 13.7543C12.5784 13.7543 13.25 13.0828 13.25 12.2543C13.25 12.0228 13.1975 11.8034 13.1038 11.6076L17.957 6.75445L19.6672 6.75426C19.8529 6.75424 20.0309 6.68047 20.1622 6.54919L21.7622 4.94885C22.2031 4.50783 21.8907 3.75385 21.2671 3.75392L20.2584 3.75403V2.73583Z",
      fill: "currentColor"
    }
  )
);
const SvgTarget = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Target_default = SvgTarget;
